import { render, staticRenderFns } from "./authenticationDetails.vue?vue&type=template&id=6c37e2f7"
import script from "./authenticationDetails.vue?vue&type=script&lang=js"
export * from "./authenticationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./authenticationDetails.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports